export default "/images/PodcastGrolmanCircularTable Talks_1366-1920.png?c534ade241bc4248b2d1af9622d075e0";